import { OktonInput, OktonSelect } from '@okton/platform-ui';
import { Box, SimpleGrid, Spinner } from '@chakra-ui/react';
import React from 'react';

export const SecaoInformacoesBasicas = ({
  dadosFormulario,
  lidarComMudancaInput,
  carregando,
}) => {
  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
      <OktonInput
        name="codigoInterno"
        label="Código Interno *"
        required
        value={dadosFormulario.codigoInterno}
        size="sm"
        onChange={lidarComMudancaInput}
      />

      <OktonInput
        name="sku"
        label="SKU *"
        required
        value={dadosFormulario.sku}
        size="sm"
        onChange={lidarComMudancaInput}
      />

      <Box gridColumn={{ md: 'span 2' }}>
        <OktonInput
          name="titulo"
          label="Título do Produto *"
          required
          value={dadosFormulario.titulo}
          size="sm"
          onChange={lidarComMudancaInput}
          autoComplete="off"
          rightElement={
            carregando ? <Spinner size="xs" color="blue.500" /> : undefined
          }
        />
      </Box>

      <OktonInput
        name="marca"
        label="Marca"
        value={dadosFormulario.marca}
        size="sm"
        onChange={lidarComMudancaInput}
      />

      <OktonInput
        name="categoria_nome"
        label="Categoria"
        value={dadosFormulario.categoria_nome}
        size="sm"
        onChange={lidarComMudancaInput}
      />

      <OktonInput
        name="codigoBarras"
        label="Código de Barras"
        value={dadosFormulario.codigoBarras}
        size="sm"
        onChange={lidarComMudancaInput}
      />

      <OktonInput
        name="ncm"
        label="NCM"
        value={dadosFormulario.ncm}
        size="sm"
        onChange={lidarComMudancaInput}
      />

      <OktonSelect
        name="status"
        label="Status *"
        required
        value={dadosFormulario.status}
        size="sm"
        onChange={lidarComMudancaInput}
        options={[
          { value: 'Ativo', label: 'Ativo' },
          { value: 'Inativo', label: 'Inativo' },
        ]}
      />
    </SimpleGrid>
  );
};
